
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore-art/kid",
      function () {
        return require("private-next-pages/explore-art/kid/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore-art/kid"])
      });
    }
  